import React from 'react';
import {
  DashboardOutlined,
  AppstoreOutlined,
  FileTextOutlined,
  ProjectOutlined,
  FileDoneOutlined,
  MessageOutlined,
  SettingOutlined,
} from '@/shared/antd-imports';
import { CheckSquareOutlined, NotificationOutlined } from '@ant-design/icons';

export interface ClientPortalMenuItems {
  key: string;
  name: string;
  icon: React.ReactNode;
  endpoint: string;
}

export const clientPortalItems: ClientPortalMenuItems[] = [
  {
    key: 'dashboard',
    name: 'navigation.dashboard',
    icon: React.createElement(DashboardOutlined),
    endpoint: 'dashboard',
  },
  {
    key: 'services',
    name: 'navigation.services',
    icon: React.createElement(AppstoreOutlined),
    endpoint: 'services',
  },
  {
    key: 'requests',
    name: 'navigation.requests',
    icon: React.createElement(FileTextOutlined),
    endpoint: 'requests',
  },
  {
    key: 'projects',
    name: 'navigation.projects',
    icon: React.createElement(ProjectOutlined),
    endpoint: 'projects',
  },
  {
    // Spec 28 §7.5 (stream abill): progress updates the provider published
    key: 'updates',
    name: 'navigation.updates',
    icon: React.createElement(NotificationOutlined),
    endpoint: 'updates',
  },
  {
    // R2-G: what the provider needs from the client (access, files, answers)
    key: 'inputs',
    name: 'navigation.inputs',
    icon: React.createElement(CheckSquareOutlined),
    endpoint: 'inputs',
  },
  {
    key: 'invoices',
    name: 'navigation.invoices',
    icon: React.createElement(FileDoneOutlined),
    endpoint: 'invoices',
  },
  {
    key: 'chats',
    name: 'navigation.chats',
    icon: React.createElement(MessageOutlined),
    endpoint: 'chats',
  },
  {
    key: 'settings',
    name: 'navigation.settings',
    icon: React.createElement(SettingOutlined),
    endpoint: 'settings',
  },
];